import React from 'react'
import clsx from 'classnames'
import styles from './Stars.module.scss'

type StarsProps = {
  name: string,
  value: number,
  onChange?: (value: number) => void,
  starsCount?: number,
}

/** Star rating; editable when onChange is passed */
export const Stars: React.FC<StarsProps> = React.memo((props) => {
  const { name, value, onChange, starsCount = 5 } = props
  return (
    <div className={styles.container}>
      {/* Highest star first: the labels float right, so they show up left to right */}
      {Array.from({ length: starsCount }, (_, i) => {
        const starValue = starsCount - i
        const id = `${name}_${starValue}`
        return (
          <React.Fragment key={starValue}>
            {onChange && (
              <input
                className={styles.input}
                type={'radio'}
                name={name}
                id={id}
                value={starValue}
                checked={value === starValue}
                onChange={() => onChange(starValue)}
              />
            )}
            <label
              className={clsx(styles.label, onChange && styles.editable)}
              htmlFor={onChange ? id : undefined}
            >
              <div className={clsx({ [styles.star]: true, [styles.active]: value >= starValue })} />
            </label>
          </React.Fragment>
        )
      })}
    </div>
  )
})
Stars.displayName = 'Stars'
